<template>
  <div ref="dropdown" class="relative">
    <TButton
      class="w-8 h-8"
      data-testid="tiptap-more"
      tooltip="More options"
      :inverse="inverse"
      :class="{
        'outline outline-2 outline-accent-1 outline-offset-[-1px]': isOpen,
      }"
      @click="isOpen = !isOpen"
    >
      <template #icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          width="20"
          height="20"
          fill="currentColor"
        >
          <circle cx="4.5" cy="10" r="1.6" />
          <circle cx="10" cy="10" r="1.6" />
          <circle cx="15.5" cy="10" r="1.6" />
        </svg>
      </template>
    </TButton>
    <!-- Right-aligned: "more" is the last item of the toolbar, so a panel
         growing to the right would hang off the toolbar (and the viewport when
         the block sits near the right edge). -->
    <div
      v-if="isOpen"
      class="absolute right-0 z-[100] w-max rounded-md border border-solid p-1 shadow-md top-[calc(100%+4px)]"
      :class="{
        'bg-gray-10 border-[color-mix(in_srgb,var(--c-g100)_60%,var(--c-g10))]':
          inverse,
        'bg-gray-900 border-gray-600': !inverse,
      }"
      @click="isOpen = false"
    >
      <TextDirection :editor="editor" :inverse="inverse" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import TextDirection from "../TextDirection/TextDirection.vue";
import { Editor } from "@tiptap/core";
import { TButton } from "@topol/twig-ui";
import { onClickOutside } from "@vueuse/core";
import { ref } from "vue";

defineProps<{
  editor: Editor;
  inverse?: boolean;
}>();

const isOpen = ref(false);
const dropdown = ref<HTMLElement>();

onClickOutside(dropdown, () => {
  isOpen.value = false;
});
</script>
